import React, { useState, useRef } from 'react';
import cx from 'classnames';
import { string, node, bool } from 'prop-types';

import { ReactComponent as ZoomInIcon } from '../../assets/zoomIn.svg';
import { ReactComponent as ZoomOutIcon } from '../../assets/zoomOut.svg';

import s from './index.module.css';

const Expand = ({
  className,
  children, 
  title,
  defaultIsExpand,
}) => {
  const contentRef = useRef(null);
  const [isExpand, setIsExpand] = useState(defaultIsExpand);

  return (
    <div className={cx(s.expand, className, {[s.expandClose]: !isExpand})}>
      <button className={s.expandButton} onClick={() => setIsExpand(!isExpand)}>
        <span className={s.title}>{title}</span>
        {isExpand ? <ZoomOutIcon /> : <ZoomInIcon className={s.zoomIn}/>}
      </button>
      <div className={s.content} style={{ maxHeight: isExpand ? (contentRef.current && contentRef.current.scrollHeight) : 0 + 'px' }} ref={contentRef}>
        {children}
      </div>
    </div>
  );
};

Expand.propTypes = {
  title: string,
  children: node,
  defaultIsExpand: bool,
};

Expand.defaultProps = {
  defaultIsExpand: false,
}

export default Expand;
